const QuestionFill = () => {
  return (
    <svg
      width="12"
      height="18"
      viewBox="0 0 12 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.65 17.025a1.167 1.167 0 1 0 0-2.333 1.167 1.167 0 0 0 0 2.333ZM11.583 4.833a4.316 4.316 0 0 0-1.8-2.966A6.05 6.05 0 0 0 5.025.958 9.45 9.45 0 0 0 1 2.7.836.836 0 1 0 2.05 4a7.767 7.767 0 0 1 3.283-1.433 4.408 4.408 0 0 1 3.467.616 2.675 2.675 0 0 1 1.125 1.825c.275 2.242-2.658 3.125-4.433 3.45l-.684.125v3.634a.833.833 0 1 0 1.667 0V9.975c5.033-1.15 5.258-3.967 5.108-5.142Z"
        fill="#9C9C9C"
      />
    </svg>
  );
};

export default QuestionFill;
